<template>
  <div class="flex flex-col">
    <!-- header -->
    <header class="z-10 px-6 pt-4 pb-2 sticky bg-white" style="top: calc(4rem + 1px)">
      <div class="flex items-center justify-between md:space-x-5">
        <div class="flex items-center space-x-5">
          <div class="flex-shrink-0">
            <div class="relative bg-violet-600/70 rounded-xl p-1">
              <mdicon name="play-box-outline" size="62" class="text-violet-100" aria-hidden="true"></mdicon>
            </div>
          </div>
          <div class="">
            <h1 class="text-2xl font-bold text-gray-900">
              {{ specData?.name }}
            </h1>
            <div class="">Configure Macro</div>
          </div>
        </div>

        <div class="flex flex-col-reverse justify-stretch space-y-4 space-y-reverse sm:flex-row-reverse sm:justify-end sm:space-x-3 sm:space-y-0 sm:space-x-reverse md:mt-0 md:flex-row md:space-x-3">
          <!--<button type="button" class="mr-2 inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50" @click="onExecuteMacros">
            <PlayIcon class="-ml-0.5 mr-1.5 h-5 w-5 text-green-700" aria-hidden="true" />
            Execute Macros
          </button>-->
          <button
            type="button"
            class="mr-2 inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            @click="onSaveMacros"
          >
            <CheckIcon class="-ml-0.5 mr-1.5 h-5 w-5" aria-hidden="true" />
            Save
          </button>
        </div>
      </div>
    </header>

    <div class="flex-auto z-0 mx-6 my-4">
      <div v-if="isTabVisible('Settings')" :class="isTabVisible('Settings') ? '' : 'lg:hidden'" class="">
        <MacrosSettingsEditor :spec-data="specData" @update:spec-prop="onSpecPropUpdate" @update:spec-script-step-prop="onSpecScriptStepPropUpdate" v-model:advanced="advanced"></MacrosSettingsEditor>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { CheckIcon } from '@heroicons/vue/20/solid';
  import { ref, reactive } from 'vue';
  import { useLayoutStore } from '@/store/LayoutStore';
  import { useBreakpoint } from '@/hooks/useBreakpoint';
  import MacrosSettingsEditor from '@/components/Macros/Edit/MacrosSettingsEditor.vue';

  const props = defineProps({
    spec: {
      type: Object,
      default() {
        return {};
      },
    },
  });
  const emit = defineEmits(['save', 'execute', 'update']);

  const layout = useLayoutStore();
  const { breakpoints } = useBreakpoint();

  const currentTab = ref('Settings');

  function isTabVisible(tabName) {
    if (layout.print || ['xs', 'sm', 'md'].includes(breakpoints.is)) {
      return true;
    }
    return currentTab.value === tabName;
  }

  const advanced = ref(false);

  // Make a full copy of the spec, and make it reactive
  const specData = reactive(JSON.parse(JSON.stringify(props.spec)));

  // TODO Support nested, i.e. specData.voice.ANI
  function onSpecPropUpdate(prop, value) {
    //console.log(`onSpecPropUpdate: ${prop} - ${value}`);
    specData[prop] = value;
    // Emit update with the whole spec ???
    emit('update', specData);
  }

  function onSpecScriptStepPropUpdate(idx, prop, value) {
    specData.embeddedScenario.script.steps[idx][prop] = value;
    // Emit update with the whole spec ???
    emit('update', specData);
  }

  async function onSaveMacros() {
    emit('save', specData);
  }
</script>
